import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import SharedFormPage from "./pages/SharedFormPage.jsx";
import './styles/variables.css'
import './styles/App.css'
import { BrowserRouter } from 'react-router-dom'
import { Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { NotificationProvider } from './components/NotificationProvider.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>    
    <BrowserRouter>
      <ErrorBoundary>
        <NotificationProvider>
          <Routes>
            <Route path="/s/:token" element={<SharedFormPage />} />
            <Route path="/*" element={<App />} />
          </Routes>
        </NotificationProvider>
      </ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
)
